import space from "../../../utils/space";
export var desktopScreenSizes = {
  width: {
    small: space(41),
    medium: space(92),
    large: space(160)
  },
  height: {
    small: space(27.5),
    medium: space(62),
    large: space(108)
  },
  scale: {
    small: 0.2485,
    medium: 0.5547
  }
};
export var tabletScreenSizes = {
  width: {
    small: space(41),
    medium: space(92),
    large: space(112)
  },
  height: {
    small: space(52.5),
    medium: space(118.5),
    large: space(144)
  },
  scale: {
    small: 0.3778,
    medium: 0.856,
    large: 1.0408
  }
};
export var mobileScreenSizes = {
  width: {
    small: space(41),
    medium: space(50.5),
    large: space(50.5)
  },
  height: {
    small: space(80),
    medium: space(99),
    large: space(99)
  }
};
export var borderWidth = 1;